export function useShowText(device: uui.domain.client.gps.wwgps.DeviceInfo) {
  return !device.virtual && !device.iconId
}
